var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _vm.href ? "a" : "div",
    _vm._g(
      _vm._b(
        {
          tag: "component",
          staticClass:
            "info-card rounded-20 d-flex flex-column justify-center bg-gray-0 pa-sm-5 pa-4",
          class: { "info-card--hover": _vm.useHover },
          attrs: { "data-qa-base": "info_card", href: _vm.href },
        },
        "component",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _c("div", { staticClass: "d-flex align-center gc-4" }, [
        _c("span", {
          staticClass: "info-card__icon bg-lpu-branding-color-primary",
          class: [
            _vm.icon,
            { "ui-icon-fz-medium info-card__icon--mobile": _setup.isMobile },
          ],
        }),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex flex-column gr-2" }, [
          _vm.title
            ? _c(
                "div",
                {
                  staticClass: "text-body-1 text-secondary--text",
                  attrs: { "data-qa": "info_card_title" },
                },
                [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.subtitle || _vm.$slots.subtitle
            ? _c(
                "div",
                { staticClass: "d-flex align-center gc-2" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "text-subtitle-1 text--text",
                      attrs: { "data-qa": "info_card_subtitle" },
                    },
                    [
                      _vm._t("subtitle", function () {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.subtitle) +
                              "\n          "
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm._t("subtitle-append-icon"),
                ],
                2
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _setup.isMobile
          ? _c("div", {
              staticClass: "ui-icon-arrow-right icon-secondary--text ml-auto",
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm._t("extra-content"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }